import Generator from '../generator';
import { api } from 'utils/api-client';

const config = {
  entities: {
    api: {
      fetchList: (type, { websiteId, ...args }) =>
        api.get(`/websites/${websiteId}/agencies`, args)
    }
  }
};

export default new Generator('agencies', config).createEntityModel();
